(() => {
  const INIT_KEY = 'data-ua-freegift-ready';

  function moneyFromPence(valueInPence) {
    return `£${(valueInPence / 100).toFixed(2)}`;
  }

  function setMessage(root, html, success = false) {
    const message = root.querySelector('[data-ua-freegift-message]');
    if (!message) return;
    message.innerHTML = html;
    message.classList.toggle('ua-freegift__message--success', success);
  }

  async function getCart() {
    const response = await fetch('/cart.js');
    if (!response.ok) throw new Error('Unable to load cart');
    return response.json();
  }

  async function addGiftVariant(variantId) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    });

    if (!response.ok) throw new Error('Unable to add gift');
    return response.json();
  }

  function getVariants(root) {
    const variantsElement = root.querySelector('[data-ua-freegift-variants]');
    if (!variantsElement) return [];

    try {
      return JSON.parse(variantsElement.textContent);
    } catch (error) {
      console.error('Invalid free gift variants JSON', error);
      return [];
    }
  }

  function buildGiftCards(root, variants) {
    const grid = root.querySelector('[data-ua-freegift-grid]');
    if (!grid || grid.childElementCount) return;

    variants.forEach((variant) => {
      const card = document.createElement('article');
      card.className = 'ua-freegift__card';

      const imageMarkup = variant.image
        ? `<img class="ua-freegift__image" src="${variant.image}" alt="${variant.title}">`
        : '';

      card.innerHTML = `
        ${imageMarkup}
        <p class="ua-freegift__card-title">${variant.title}</p>
        <button type="button" class="button button--secondary ua-freegift__add" data-variant-id="${variant.id}">
          Add to cart
        </button>
      `;

      grid.appendChild(card);
    });

    grid.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-variant-id]');
      if (!button) return;

      const variantId = Number(button.dataset.variantId);
      if (!variantId) return;

      grid.querySelectorAll('[data-variant-id]').forEach((item) => item.setAttribute('disabled', 'disabled'));
      button.textContent = 'Adding...';

      try {
        await addGiftVariant(variantId);
        button.textContent = 'Added';
        window.location.reload();
      } catch (error) {
        console.error(error);
        grid.querySelectorAll('[data-variant-id]').forEach((item) => item.removeAttribute('disabled'));
        button.textContent = 'Try again';
      }
    });
  }

  async function evaluatePromo(root) {
    const code = root.dataset.code || '';
    const giftHandle = root.dataset.giftHandle || '';
    const minSpend = Number(root.dataset.minSpend || 0);
    const input = root.querySelector('.ua-freegift__input');
    const giftBox = root.querySelector('[data-ua-freegift-box]');

    if (!input || !giftBox) return;

    try {
      const cart = await getCart();
      const subtotal = cart.total_price;
      const hasGift = cart.items.some((item) => item.handle === giftHandle);
      const enteredCode = input.value.trim().toUpperCase();

      if (subtotal < minSpend) {
        const shortfall = minSpend - subtotal;
        giftBox.hidden = true;
        setMessage(
          root,
          `You're only ${moneyFromPence(shortfall)} away from your complimentary pendant.<br><a href="/collections/all">Continue shopping</a>`
        );
        return;
      }

      if (hasGift) {
        giftBox.hidden = true;
        setMessage(root, 'A complimentary gift is already in your basket.', true);
        return;
      }

      if (enteredCode === code) {
        buildGiftCards(root, getVariants(root));
        giftBox.hidden = false;
        setMessage(root, 'Code accepted. Choose your complimentary pendant below.', true);
        return;
      }

      if (enteredCode) {
        giftBox.hidden = true;
        setMessage(root, `That code isn't recognised. Try ${code}.`);
        return;
      }

      giftBox.hidden = true;
      setMessage(
        root,
        `Add an item to your basket and enter <strong>${code}</strong> to unlock your complimentary pendant (worth £75).<br><a href="/collections/all">Browse all products</a>`
      );
    } catch (error) {
      console.error(error);
    }
  }

  function initPromo(root) {
    if (root.hasAttribute(INIT_KEY)) return;
    root.setAttribute(INIT_KEY, 'true');

    const input = root.querySelector('.ua-freegift__input');
    const applyButton = root.querySelector('.ua-freegift__apply');
    const checkoutButton = root.closest('#main-cart-footer, .drawer__footer, .cart-drawer__footer, .cart__footer')?.querySelector('button[name="checkout"]');

    const urlCode = new URLSearchParams(window.location.search).get('discount');
    if (urlCode && urlCode.toUpperCase() === (root.dataset.code || '').toUpperCase() && input) {
      input.value = urlCode.toUpperCase();
    }

    if (applyButton) {
      applyButton.addEventListener('click', () => evaluatePromo(root));
    }

    if (input) {
      input.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        evaluatePromo(root);
      });
    }

    if (checkoutButton && !checkoutButton.hasAttribute('data-ua-freegift-checkout')) {
      checkoutButton.setAttribute('data-ua-freegift-checkout', 'true');
      checkoutButton.addEventListener('click', (event) => {
        if (!input) return;
        const enteredCode = input.value.trim().toUpperCase();
        const configuredCode = (root.dataset.code || '').toUpperCase();

        if (enteredCode !== configuredCode) return;

        event.preventDefault();
        window.location.href = `/checkout?discount=${encodeURIComponent(configuredCode)}`;
      });
    }

    evaluatePromo(root);
  }

  function initAllPromos(scope = document) {
    scope.querySelectorAll('[data-ua-freegift]').forEach(initPromo);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initAllPromos();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;
          if (node.matches('[data-ua-freegift]')) initPromo(node);
          initAllPromos(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
